/* eslint-disable max-lines */
/* eslint-disable max-statements */
// 9fbef606107a605d69c0edbcd8029e5d
import { call, put, takeLatest, select, delay } from 'redux-saga/effects';
import isEmpty from 'lodash/isEmpty';
import logger from '@tcp/core/src/utils/loggerInstance';
import processHelperUtil from '@tcp/core/src/services/abstractors/productListing/ProductDetail.util';
import { FAVORITES_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import {
  getIsAutoSaveOnLoginEnabled,
  getIsGuestFavAppEnabled,
  getIsGuestFavEnabled,
  getAddToDefaultFavoritesEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import getErrorList from '@tcp/core/src/components/features/CnC/BagPage/container/Errors.selector';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import { formatProductsData, getPageName } from '@tcp/core/src/utils/utils';
import { getFavoriteStore } from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.selectors';
import { toastMessageInfo } from '@tcp/core/src/components/common/atoms/Toast/container/Toast.actions';
import {
  setDefaultWishListIdActn,
  setDeleteFavItemProgress,
  setPendingAddWishlistProduct,
} from '@tcp/core/src/components/features/browse/Favorites/container/Favorites.actions';
import LoginPageDynamicStore from '@tcp/core/src/components/features/account/LoginPage/container/LoginPageDynamicStore';
import { getUnbxdXappConfigs } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.saga';
import { routerPush, setSessionStorage, getSessionStorage, getSiteId } from '@tcp/core/src/utils';
import FAVORITES_CONSTANTS from './Favorites.constants';
import { isCanada } from '../../../../../utils';
import {
  wishListFromState as defaultWishListFromState,
  selectDefaultWishlistId,
} from './Favorites.selectors';
import { getProfile } from '../../../../../services/abstractors/account/Login';
import names from '../../../../../constants/eventsName.constants';
import {
  setWishlistState,
  setWishlistsSummariesAction,
  getSetIsWishlistReadOnlyAction,
  setActiveWishlistAction,
  getActiveWishlistAction,
  setDeletedItemAction,
  setLoadingState,
  setAddToFavoriteErrorState,
  setWishListShareSuccess,
  setMaximumProductAddedErrorState,
  resetMaximumProductAddedErrorState,
  getSetDefaultWishListActn,
  showToastModal,
  showATFflyout,
} from './Favorites.actions';

import addItemsToWishlistAbstractor, {
  getUserWishLists,
  getWishListbyId,
  getProductsPrices,
  createWishList,
  moveItemToNewWishList,
  deleteWishList,
  updateWishlistName,
  deleteWishListItem,
  shareWishlistByEmail,
  getWishListsAndWishlistWithId,
  getPublicWishListItems,
  removeOOSItemFromWishlist,
} from '../../../../../services/abstractors/productListing/favorites';
import {
  getUserLoggedInState,
  getUserContactInfo,
  isRememberedUser,
} from '../../../account/User/container/User.selectors';
import { setLoginModalMountedState } from '../../../account/LoginPage/container/LoginPage.actions';
import { setAddToFavorite } from '../../ProductListing/container/ProductListing.actions';
import {
  setAddToFavoritePDP,
  removeAddToFavoritePDP,
} from '../../ProductDetail/container/ProductDetail.actions';
import { setAddToFavoriteSLP } from '../../SearchDetail/container/SearchDetail.actions';
import {
  setAddToFavoriteOUTFIT,
  removeOutfitFavoriteItemAction,
} from '../../OutfitDetails/container/OutfitDetails.actions';
import { setAddToFavoriteBUNDLE } from '../../BundleProduct/container/BundleProduct.actions';
import pushEventToAdobeAnalytics from '../../../../../adobeAnalytics/adobe.utils';

function getGuestFavCheck(isGuest, isGuestFavWebEnabled) {
  return isGuest && isGuestFavWebEnabled;
}

export function* renderWishlistItem({ wishlistItemRender, wishListId, wishListName = '' }) {
  const state = yield select();
  const defaultWishlistID = yield select(selectDefaultWishlistId);
  const userName = getUserContactInfo(state).get('firstName');
  const xappURLConfig = yield call(getUnbxdXappConfigs);
  const isGuest = !getUserLoggedInState({ ...state });
  const isGuestFavEnabled = getIsGuestFavEnabled(state);
  const guestFavCheck = isGuest && isGuestFavEnabled;
  if (guestFavCheck) {
    yield put(setLoadingState({ isDataLoading: true }));
  }

  const wishlistItems = wishlistItemRender?.items;
  if (wishlistItems.length !== 0) {
    const prices = yield call(
      getProductsPrices,
      wishlistItems.map((wishlist) => wishlist.skuInfo.colorProductId),
      xappURLConfig
    );
    const WishlistWithUnbxdPrice = wishlistItems.map((wishlist) => {
      return {
        ...wishlist,
        productInfo: {
          ...wishlist.productInfo,
          ...prices[wishlist.skuInfo.colorProductId],
        },
      };
    });
    const updatedWishList = {
      ...wishlistItemRender,
      isDefault: defaultWishlistID === wishListId,
      items: [...WishlistWithUnbxdPrice],
    };
    yield put(setActiveWishlistAction(updatedWishList));
    if (guestFavCheck) {
      yield put(setLoadingState({ isDataLoading: false }));
    }
  } else {
    yield put(
      setActiveWishlistAction({
        id: wishListId,
        displayName: wishListName,
        creatorName: userName,
        isDefault: defaultWishlistID === wishListId,
        items: [],
      })
    );
    if (guestFavCheck) {
      yield put(setLoadingState({ isDataLoading: false }));
    }
  }
}
export function* loadActiveWishlistByGuestKey({ payload }) {
  const { wishListId, guestAccessKey } = payload;
  try {
    const state = yield select();

    yield put(setLoadingState({ isDataLoading: true }));
    const userState = getUserContactInfo(state);
    const userName = userState && userState.get('firstName');
    const isCanadaCheck = isCanada();
    const wishlistItems = yield call(getPublicWishListItems, {
      wishListId,
      userName,
      guestAccessKey,
      isCanada: isCanadaCheck,
      imageGenerator: processHelperUtil.getImgPath,
    });
    yield put(getSetIsWishlistReadOnlyAction(true));
    yield put(setActiveWishlistAction(wishlistItems));
    yield put(setLoadingState({ isDataLoading: false }));
    return wishlistItems;
  } catch (err) {
    yield put(setLoadingState({ isDataLoading: false }));
    return [];
  }
}

function* showToastIfGuestFavEnabled(operation, isGuest, isGuestFavEnabled, isGuestFavAppEnabled) {
  if (operation === 'add' && isGuest && (isGuestFavEnabled || isGuestFavAppEnabled)) {
    yield put(showToastModal({ duration: 5000, showToast: true }));
  }
}

function defaultWishlistIdSetter(guestFavCheck, wishListId) {
  let newWishListId = wishListId;
  try {
    if (guestFavCheck && isEmpty(wishListId)) {
      newWishListId = getSessionStorage(`defaultWishlistid${getSiteId()}`);
    }
  } catch (error) {
    logger.error(error);
  }
  return newWishListId;
}

const isLoggedInOrGuestFavCheck = ({ isGuest, isRemembered, guestFavCheck }) => {
  return (!isGuest && !isRemembered) || guestFavCheck;
};

const shouldFetchDefaultWishList = ({ defaultWishListItems, makeApiCall, defaultWishlistId }) => {
  return (defaultWishListItems === null || makeApiCall) && defaultWishlistId;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export function* getDefaultWishList(
  makeApiCall = false,
  wishListName = '',
  activeWishlistID = '',
  page = '',
  operation = '',
  additionalParams = {}
) {
  try {
    const state = yield select();
    const isGuest = !getUserLoggedInState({ ...state });
    const isRemembered = isRememberedUser({ ...state });
    const isGuestFavWebEnabled = getIsGuestFavEnabled(state);
    const isGuestFavAppEnabled = yield select(getIsGuestFavAppEnabled);
    const isGuestFavEnabled = isGuestFavWebEnabled;
    const guestFavCheck = isGuest && isGuestFavEnabled;
    const userName = getUserContactInfo(state)?.get('firstName');
    let defaultWishlistId = activeWishlistID || (yield select(selectDefaultWishlistId));
    defaultWishlistId = defaultWishlistIdSetter(guestFavCheck, defaultWishlistId);
    const { fromFavoriteListModal } = additionalParams || {};

    if (isLoggedInOrGuestFavCheck({ isGuest, isRemembered, guestFavCheck })) {
      let defaultWishListItems = yield select(defaultWishListFromState);
      if (shouldFetchDefaultWishList({ defaultWishListItems, makeApiCall, defaultWishlistId })) {
        defaultWishListItems = yield call(getWishListbyId, {
          wishListId: defaultWishlistId,
          wishListName,
          userName,
          guestAccessKey: null,
          isCanada: isCanada(),
          imageGenerator: processHelperUtil.getImgPath,
        });
        if (fromFavoriteListModal) {
          yield put(showATFflyout(true));
        }
        if (page === 'SBP') {
          yield put(setActiveWishlistAction(defaultWishListItems));
        } else {
          yield put(getSetDefaultWishListActn({ ...defaultWishListItems }));
          yield put(setDeleteFavItemProgress(false));
          yield call(
            showToastIfGuestFavEnabled,
            operation,
            isGuest,
            isGuestFavEnabled,
            isGuestFavAppEnabled
          );
        }
      }
    }
  } catch (err) {
    yield put(setLoadingState({ isDataLoading: false }));
    yield put(showATFflyout(false));
    yield null;
  }
}

const getBreadCrumb = (breadCrumbs) => {
  if (breadCrumbs) {
    const breadCrumbsArray = breadCrumbs.map((breadCrumb) => breadCrumb.displayName.toLowerCase());
    return breadCrumbsArray.join(':');
  }

  return null;
};

export function* loadActiveWishlist({ wishListId, wishListName }) {
  const state = yield select();
  const userName = getUserContactInfo(state).get('firstName');
  try {
    const wishlistItemRender = yield call(getWishListbyId, {
      wishListId,
      wishListName,
      userName,
      guestAccessKey: null,
      isCanada: isCanada(),
      imageGenerator: processHelperUtil.getImgPath,
    });
    yield* renderWishlistItem({ wishlistItemRender, wishListId, wishListName });
  } catch (err) {
    yield put(setLoadingState({ isDataLoading: false }));
    yield null;
  }
}

/* eslint-disable sonarjs/cognitive-complexity */
// eslint-disable-next-line complexity
export function* addItemsToWishlist({ payload }) {
  const {
    colorProductId,
    productSkuId,
    pdpColorProductId,
    formName,
    page,
    products,
    customData,
    breadCrumbs,
    activeWishListId: payloadWishlistId,
    wishListName = '',
  } = payload;
  const state = yield select();
  const storeId = getFavoriteStore(state);
  const isGuest = !getUserLoggedInState(state);
  const isGuestFavEnabled = getIsGuestFavEnabled(state);
  const defaultWishlistLimit = 5;
  const errorMapping = getErrorList(state);
  const productsFormatted = products ? formatProductsData(products, customData) : null;
  const pageShortName = products ? getPageName(products) : null;
  let skuIdOrProductId;
  let isProduct = true;
  const quantity =
    formName && state.form[`${formName}-${colorProductId}`]
      ? state.form[`${formName}-${colorProductId}`].values.Quantity
      : 1;

  if (productSkuId) {
    skuIdOrProductId = productSkuId;
    isProduct = false;
  } else {
    skuIdOrProductId = colorProductId;
  }

  let activeWishlistID;
  if (payloadWishlistId) {
    activeWishlistID = payloadWishlistId;
  } else {
    activeWishlistID = yield select(selectDefaultWishlistId);
  }
  try {
    yield put(setAddToFavoriteErrorState({ errorMessage: '' }));
    if (isGuest && !getGuestFavCheck(isGuest, isGuestFavEnabled)) {
      const isAutoSaveEnabled = yield select(getIsAutoSaveOnLoginEnabled);
      if (isAutoSaveEnabled && page === 'PLP') {
        const pendingWishlistPayload = {
          colorProductId,
          productSkuId,
          pdpColorProductId,
          formName,
          page,
          products,
        };
        yield put(setPendingAddWishlistProduct({ ...pendingWishlistPayload }));
      }
      yield LoginPageDynamicStore();
      yield put(setLoginModalMountedState({ state: true, isAccountCardVisible: true }));
    } else {
      yield put(resetMaximumProductAddedErrorState({}));
      yield put(setDeleteFavItemProgress(true));
      if (getGuestFavCheck(isGuest, isGuestFavEnabled)) {
        const defaultWishlist = defaultWishListFromState(state)?.items;
        if (defaultWishlist?.length >= defaultWishlistLimit) {
          const pendingWishlistPayload = {
            colorProductId,
            page,
            products,
          };
          yield put(setPendingAddWishlistProduct({ ...pendingWishlistPayload }));
          const { pathname = 'referrer' } = (window && window?.location) || {};
          const target = 'login'; // The target page you want to navigate to
          const successTarget = pathname; // The success target page (current page) after login

          const href = `/home?target=${target}&successtarget=${successTarget}&fromGuestFav=true`;
          const as = '/home/login';

          const query = {}; // Add any additional query parameters if needed
          yield put(
            showToastModal({
              duration: 0,
              showToast: false,
            })
          );
          yield put(setDeleteFavItemProgress(false));
          yield call(routerPush, href, as, query);
          return;
        }
      }
      const res = yield call(addItemsToWishlistAbstractor, {
        wishListId: activeWishlistID || '',
        skuIdOrProductId,
        quantity,
        isProduct,
        uniqueId: colorProductId,
        errorMapping,
      });
      const userName = getUserContactInfo(state)?.get('firstName');
      let wishlistName = wishListName;

      if (activeWishlistID === null || activeWishlistID === '') {
        const wishlists = yield call(getUserWishLists, userName);
        const activewishlistid = wishlists.filter((item) => {
          return (
            item.productsList.length &&
            item.productsList.filter((key) => key.id === res.newItemId).length
          );
        });
        if (activewishlistid.length && activewishlistid[0].id) {
          yield put(setDefaultWishListIdActn(activewishlistid[0].id));
          setSessionStorage({
            key: `defaultWishlistid${getSiteId()}`,
            value: activewishlistid[0].id,
          });
          wishlistName = activewishlistid[0].displayName;
        }
      }

      yield put(
        setClickAnalyticsData({
          customEvents: [names.eVarPropEvent.event52, names.eVarPropEvent.event94],
          pageName: pageShortName,
          products: productsFormatted,
          pageNavigationText: '',
          eventName: 'wishlist add item',
          linkName: 'wishlist add item',
          storeId,
          clickEvent: true,
          breadcrumb: getBreadCrumb(breadCrumbs),
        })
      );

      pushEventToAdobeAnalytics('add_to_wishlist', payload);
      yield put(trackClick({ name: 'add_to_wishlist', module: 'browse' }));
      yield call(getDefaultWishList, true, wishlistName, activeWishlistID, page, 'add');

      if (res && res.errorMessage) {
        yield put(setAddToFavoriteErrorState(res));
        yield put(setDeleteFavItemProgress(false));
        const errorMessages = {
          errorMessage: res.errorMessage,
          itemId: colorProductId,
        };
        const data = {};
        data[colorProductId] = errorMessages;
        yield put(setMaximumProductAddedErrorState({ ...data }));
      }

      if (res && res.newItemId) {
        switch (page) {
          case 'PDP':
            yield put(setAddToFavoritePDP({ pdpColorProductId, res }));
            break;
          case 'PLP':
            yield put(setAddToFavorite({ colorProductId, res }));
            break;
          case 'SLP':
            yield put(setAddToFavoriteSLP({ colorProductId, res }));
            break;
          case 'OUTFIT':
            yield put(setAddToFavoriteOUTFIT({ pdpColorProductId, res }));
            break;
          case 'BUNDLE':
            yield put(setAddToFavoriteBUNDLE({ pdpColorProductId, res }));
            break;
          default:
            break;
        }
        // to update favorite page need to load wish list sumamry
        // yield* loadActiveWishlist({activeWishlistId, displayName})
        yield put(setWishlistState({ colorProductId, isInDefaultWishlist: true }));
        yield put(setDeleteFavItemProgress(false));
      }
    }
  } catch (err) {
    yield put(setDeleteFavItemProgress(false));
    logger.error(err);
  }
}

function updateWishlistItems(wishlistItems, prices) {
  return wishlistItems.map((wishlist) => ({
    ...wishlist,
    productInfo: {
      ...wishlist.productInfo,
      ...prices[wishlist.skuInfo.colorProductId],
    },
  }));
}

/**
 * Load user wishlists and also fetch details of wishlist by wishlistId
 *
 * @param {*} { wishlistId, wishlistName, isSBP }
 */
export function* loadWishlistsSummariesWithDetails({ wishlistId, wishlistName }) {
  const state = yield select();
  const defaultWishlistID = yield select(selectDefaultWishlistId);
  const isGuest = !getUserLoggedInState(state);
  const isGuestFavEnabled = getIsGuestFavEnabled(state);
  const userName = getUserContactInfo(state)?.get('firstName');
  const addToDefaultFavoritesEnabled = getAddToDefaultFavoritesEnabled(state);
  try {
    const xappURLConfig = yield call(getUnbxdXappConfigs);
    yield put(setLoadingState({ isDataLoading: true }));

    let wishlists = [];
    let wishlistById = {};
    // Make GraphQL call for getting user wishlists and wishlistById
    ({ wishlists, wishlistById } = yield call(getWishListsAndWishlistWithId, {
      userName,
      wishlistId,
      wishlistName,
      isCanada: isCanada(),
      imageGenerator: processHelperUtil.getImgPath,
    }));

    // Yield wishlistById in case a promise is returned
    wishlistById = yield wishlistById;
    // Set isDefault flag for each wishlist
    wishlists = wishlists.map((wishlist) => ({
      ...wishlist,
      isDefault: wishlist.id === defaultWishlistID,
    }));
    yield put(setWishlistsSummariesAction(wishlists));

    // Set wishlist details received from wishlistById
    if (wishlistById && wishlistById?.items?.length !== 0) {
      const wishlistItems = wishlistById?.items;
      const prices = yield call(
        getProductsPrices,
        wishlistItems.map((wishlist) => wishlist.skuInfo.colorProductId),
        xappURLConfig
      );
      const updatedWishlist = {
        ...wishlistById,
        isDefault: defaultWishlistID === wishlistId,
        items: updateWishlistItems(wishlistItems, prices),
      };
      if (
        getGuestFavCheck(isGuest, isGuestFavEnabled) ||
        (addToDefaultFavoritesEnabled && !isGuest)
      ) {
        yield put(getSetDefaultWishListActn(updatedWishlist));
      }
      yield put(setActiveWishlistAction(updatedWishlist));
    } else {
      yield put(
        setActiveWishlistAction({
          id: wishlistId,
          displayName: wishlistName,
          creatorName: userName,
          isDefault: defaultWishlistID === wishlistId,
          items: [],
        })
      );
      if (getGuestFavCheck(isGuest, isGuestFavEnabled)) {
        yield put(
          getSetDefaultWishListActn({
            id: wishlistId,
            displayName: wishlistName,
            creatorName: userName,
            isDefault: defaultWishlistID === wishlistId,
            items: [],
          })
        );
      }
    }
    yield put(setLoadingState({ isDataLoading: false }));
  } catch (e) {
    yield put(
      setActiveWishlistAction({
        id: wishlistId,
        displayName: wishlistName,
        creatorName: userName,
        isDefault: defaultWishlistID === wishlistId,
        items: [],
      })
    );
    yield null;
  } finally {
    yield put(setLoadingState({ isDataLoading: false }));
  }
}

function* setLoaderFunc(guestFavCheck) {
  if (guestFavCheck) {
    yield put(setLoadingState({ isDataLoading: false }));
  }
}

// eslint-disable-next-line complexity
export function* loadWishlistsSummaries(config, wishlistName = '') {
  try {
    const state = yield select();
    const isGuest = !getUserLoggedInState({ ...state });
    const isGuestFavEnabled = getIsGuestFavEnabled(state);
    const guestFavCheck = getGuestFavCheck(isGuest, isGuestFavEnabled);
    let wishListId;
    let nameOfWishlist;
    if (guestFavCheck) {
      yield put(setLoadingState({ isDataLoading: true }));
    }
    if (typeof config !== 'object') {
      wishListId = config;
    } else if (typeof config === 'object') {
      const { isDataLoading } = config.payload;
      wishListId = config?.payload?.wishListId || '';
      nameOfWishlist = config?.payload?.wishlistName || '';
      if (!guestFavCheck) {
        yield put(setLoadingState({ isDataLoading: isDataLoading || false }));
      }
      wishListId = defaultWishlistIdSetter(guestFavCheck, wishListId);
    }
    if (isEmpty(wishListId)) {
      // Active wishlistId not passed
      // Make two separate queries for getting wishlists and default wishlist detail
      const userName = getUserContactInfo(state)?.get('firstName');
      let wishlists = yield call(getUserWishLists, userName);
      const defaultWishlistID = yield select(selectDefaultWishlistId);
      wishlists = wishlists.map((wishlist) => {
        const defaultWishlist = wishlist;
        if (wishlist.id === defaultWishlistID) {
          defaultWishlist.isDefault = true;
        }
        return {
          ...wishlist,
        };
      });
      if (defaultWishlistID) {
        yield put(setWishlistsSummariesAction(wishlists));
        const defaultWishlist = wishlists.find((list) => list.isDefault) || {};
        yield put(
          getActiveWishlistAction(defaultWishlist?.id, defaultWishlist?.displayName || userName)
        );
      } else {
        const FAKE_WISHLIST_ID = 'fake_sv2a9';
        if (wishlists?.[0]?.id === FAKE_WISHLIST_ID) {
          yield put(setWishlistsSummariesAction(wishlists));
        } else {
          yield put(
            setWishlistsSummariesAction([
              {
                id: FAKE_WISHLIST_ID,
                displayName: `${userName}'s Favorites`,
                isDefault: true,
                shareableLink: '',
                creatorName: userName,
                itemCount: 0,
              },
              ...wishlists,
            ])
          );
        }
        yield call(setLoaderFunc(guestFavCheck));
      }
      if (!guestFavCheck) {
        yield put(setLoadingState({ isDataLoading: false }));
      }
    } else {
      // Active wishlistId passed
      // Make a combined query for wishlists and active wishlist detail
      yield call(loadWishlistsSummariesWithDetails, {
        wishlistId: wishListId,
        wishlistName: nameOfWishlist || wishlistName,
      });
    }
  } catch (err) {
    yield put(setLoadingState({ isDataLoading: false }));
    yield null;
  }
}

export function* createNewWishList({ payload: formData }) {
  try {
    const storeId = yield select(getFavoriteStore);
    const createdWishListResponse = yield call(
      createWishList,
      formData.wishListName,
      formData.isDefault
    );
    yield put(
      setClickAnalyticsData({
        customEvents: ['event64'],
        products: [],
        pageNavigationText: '',
        pageName: 'favorites',
        storeId,
        clickEvent: true,
      })
    );
    yield put(
      trackClick({
        name: 'create_wishlist',
        module: 'browse',
      })
    );
    if (formData.isDefault && createdWishListResponse?.id) {
      yield put(setDefaultWishListIdActn(createdWishListResponse.id));
    }
    yield* loadWishlistsSummaries(createdWishListResponse.id, formData.wishListName);
    if (formData.isDefault) {
      yield call(getDefaultWishList, true);
    }
  } catch (err) {
    yield null;
  }
}

export function* createNewWishListMoveItem({ payload: formData }) {
  try {
    yield put(resetMaximumProductAddedErrorState({}));
    const state = yield select();
    const errorMapping = getErrorList(state);
    let createdWishListResponse;
    if (!formData.wisListId) {
      createdWishListResponse = yield call(
        createWishList,
        formData.wishListName,
        formData.isDefault
      );
    }
    const payload = {
      toWishListId: formData.wisListId || createdWishListResponse.id,
      itemId: formData.itemId,
    };
    const activeWishlistObject =
      state[FAVORITES_REDUCER_KEY] && state[FAVORITES_REDUCER_KEY].get('activeWishList');
    const activeWishlistId = formData?.fromFavoriteListModal
      ? formData.fromWishListID
      : activeWishlistObject.id;
    const activeWishlistItem = formData?.fromFavoriteListModal
      ? formData.item
      : activeWishlistObject.items.find((item) => item.itemInfo.itemId === formData.itemId);

    const itemMovedResponse = yield call(
      moveItemToNewWishList,
      payload,
      activeWishlistId,
      activeWishlistItem,
      errorMapping
    );
    if (itemMovedResponse && itemMovedResponse.errorMessage) {
      const errorMessages = {
        errorMessage: itemMovedResponse.errorMessage,
        itemId: formData.itemId,
      };
      const data = {};
      data[formData.itemId] = errorMessages;
      yield put(setMaximumProductAddedErrorState({ ...data }));
    } else if (!formData.fromFavoriteListModal) {
      yield* loadWishlistsSummaries(activeWishlistId, activeWishlistObject.displayName);
    }
    if (!itemMovedResponse.success) {
      throw itemMovedResponse;
    }
  } catch (err) {
    yield null;
  }
}
export function* deleteOOSItemFromWishlist({ payload }) {
  const state = yield select();
  const userName = getUserContactInfo(state).get('firstName');
  try {
    yield put(setLoadingState({ isDataLoading: true }));
    const { wishListId, wishListName } = payload;
    const wishlistItemRender = yield call(removeOOSItemFromWishlist, {
      wishListId,
      wishListName,
      isCanada: isCanada(),
      userName,
    });
    yield* renderWishlistItem({ wishlistItemRender, wishListId, wishListName });

    yield put(setLoadingState({ isDataLoading: false }));
  } catch (err) {
    yield put(setLoadingState({ isDataLoading: false }));
    yield null;
  }
}
export function* deleteWishListById({ payload }) {
  const storeId = yield select(getFavoriteStore);
  try {
    const { wishListId, isDefault, products, deleteOOSItems } = payload;
    const deleteWishListResponse = yield call(deleteWishList, wishListId, deleteOOSItems);
    yield put(
      setClickAnalyticsData({
        customEvents: ['event54'],
        products,
        pageNavigationText: '',
        pageName: 'favorites',
        storeId,
        clickEvent: true,
      })
    );
    yield put(
      trackClick({
        name: 'delete_wishlist',
        module: 'browse',
      })
    );
    if (!deleteWishListResponse.success) {
      throw deleteWishListResponse;
    }

    if (isDefault) {
      const response = yield call(getProfile, { refresh: false });
      if (response.defaultWishListId) {
        yield put(setDefaultWishListIdActn(response.defaultWishListId));
      }
    }
    yield* loadWishlistsSummaries();
    if (isDefault) {
      yield call(getDefaultWishList, true);
    }
  } catch (err) {
    yield null;
  }
}

export function* updateExistingWishList({ payload: formData }) {
  try {
    const updateWishListResponse = yield call(
      updateWishlistName,
      formData.wishlistId,
      formData.wishlistName,
      formData.setAsDefault
    );
    if (formData.setAsDefault && updateWishListResponse.success) {
      yield put(setDefaultWishListIdActn(formData.wishlistId));
    }
    if (!updateWishListResponse.success) {
      throw updateWishListResponse;
    }
    yield* loadWishlistsSummaries(formData.wishlistId, formData.wishlistName);
    if (formData.setAsDefault) {
      yield call(getDefaultWishList, true, formData.wishlistName, '', '', '', {
        fromFavoriteListModal: formData.fromFavoriteListModal,
      });
    }
  } catch (err) {
    yield null;
  }
}

// eslint-disable-next-line complexity
export function* deleteWishListItemById({ payload }) {
  const storeId = yield select(getFavoriteStore);
  let deleteItemResponse = '';
  try {
    const { products, toastMessage } = payload;
    const state = yield select();
    const activeWishlistObject =
      state[FAVORITES_REDUCER_KEY] && state[FAVORITES_REDUCER_KEY].get('activeWishList');
    const activeWishlistId = activeWishlistObject && activeWishlistObject.id;
    if (payload && (payload.notFromFavoritePage || payload.isSBP)) {
      yield put(setDeleteFavItemProgress(true));
      deleteItemResponse = yield call(
        deleteWishListItem,
        payload.externalId,
        payload.itemId,
        payload.productId
      );
      pushEventToAdobeAnalytics('remove_from_wishlist', payload);
    } else {
      deleteItemResponse = yield call(
        deleteWishListItem,
        activeWishlistId,
        payload.itemId,
        products.generalProductId
      );
    }

    const productsFormatted = products ? formatProductsData(products) : null;
    if (!deleteItemResponse.success) {
      throw deleteItemResponse;
    }

    yield put(
      setClickAnalyticsData({
        customEvents: ['event53'],
        pageName: 'favorites',
        products: productsFormatted,
        pageNavigationText: '',
        storeId,
        clickEvent: true,
      })
    );

    yield put(
      trackClick({
        name: 'remove_from_wishlist',
        module: 'browse',
      })
    );
    if (payload.notFromFavoritePage) {
      yield call(
        getDefaultWishList,
        true,
        payload.notFromFavoritePage ? payload?.wishListName : activeWishlistObject?.displayName
      );
    } else {
      pushEventToAdobeAnalytics('remove_from_wishlist', payload?.products);
      yield* loadWishlistsSummaries(
        deleteItemResponse?.res?.removeItemFromWishList?.wishListId,
        payload.notFromFavoritePage ? payload?.wishListName : activeWishlistObject?.displayName
      );
    }
    yield put(setDeletedItemAction(payload.itemId));
    yield put(removeAddToFavoritePDP({ payload, deleteItemResponse }));
    yield put(removeOutfitFavoriteItemAction(payload));
    yield put(setDeleteFavItemProgress(false));
    yield delay(4000);
    yield put(toastMessageInfo(toastMessage));
    yield put(setDeleteFavItemProgress(false));
  } catch (err) {
    yield put(setDeleteFavItemProgress(false));
    yield null;
  }
}

export function* updateWishListItem({ payload }) {
  try {
    const { itemId, quantity, color, productId, product, callBack } = payload;
    const state = yield select();
    const activeWishlistObject =
      state[FAVORITES_REDUCER_KEY] && state[FAVORITES_REDUCER_KEY].get('activeWishList');
    const activeWishlistId = activeWishlistObject.id;
    const variantSelected =
      product &&
      product.colorFitsSizesMap &&
      product.colorFitsSizesMap.find((entry) => entry.color.name === color);
    const uniqueId = (variantSelected && variantSelected.colorDisplayId) || '';
    yield call(deleteWishListItem, activeWishlistId, itemId, productId);
    yield call(addItemsToWishlistAbstractor, {
      wishListId: activeWishlistId,
      skuIdOrProductId: uniqueId,
      quantity,
      isProduct: true,
      uniqueId,
    });
    yield* loadWishlistsSummaries(activeWishlistId, activeWishlistObject.displayName);
    if (callBack) {
      callBack();
    }
  } catch (err) {
    yield null;
  }
}

export function* sendWishListMail(formData) {
  try {
    const state = yield select();
    const activeWishlistObject =
      state[FAVORITES_REDUCER_KEY] && state[FAVORITES_REDUCER_KEY].get('activeWishList');
    const activeWishlistId = activeWishlistObject.id;
    const { shareToEmailAddresses, shareFromEmailAddresses, shareSubject, shareMessage } =
      formData.payload;
    const emailSentResponse = yield call(
      shareWishlistByEmail,
      activeWishlistId,
      shareFromEmailAddresses,
      shareToEmailAddresses.split(','),
      shareSubject,
      shareMessage
    );

    if (emailSentResponse.successful) {
      yield put(setWishListShareSuccess(true));
    }
  } catch (err) {
    yield null;
  }
}

export function* replaceWishlistItem(payload) {
  try {
    yield* deleteWishListItemById(payload);
    yield* addItemsToWishlist(payload);
    const {
      payload: { activeWishListId },
    } = payload;
    yield* loadWishlistsSummaries(activeWishListId);
  } catch (err) {
    yield null;
  }
}

export function* createNewWishListAddItem({ payload }) {
  const payloadObj = payload;
  try {
    yield put(resetMaximumProductAddedErrorState({}));
    /*
      On each click of favorites icon, a new wish list was getting created
      But we need single wishlist for a profile. This check will detect if the
      there is already a wish list active for this profile, then it would reuse
      that instead of creating a new one.
    */
    if (!payloadObj.activeWishListId) {
      const createdWishListResponse = yield call(
        createWishList,
        payload.wishListName,
        payload.isDefault
      );
      payloadObj.activeWishListId = createdWishListResponse.id;
    }
    yield* addItemsToWishlist({ payload: payloadObj });
    yield* loadWishlistsSummaries(payloadObj.activeWishListId);
  } catch (e) {
    yield null;
  }
}

function* FavoriteSaga() {
  yield takeLatest(FAVORITES_CONSTANTS.SET_FAVORITES, addItemsToWishlist);
  yield takeLatest(FAVORITES_CONSTANTS.GET_USER_FAVORITES, getDefaultWishList);
  yield takeLatest(FAVORITES_CONSTANTS.GET_FAVORITES_WISHLIST, loadWishlistsSummaries);
  yield takeLatest(FAVORITES_CONSTANTS.LOAD_ACTIVE_FAVORITES_WISHLIST, loadActiveWishlist);
  yield takeLatest(
    FAVORITES_CONSTANTS.LOAD_ACTIVE_FAVORITES_WISHLIST_GUEST,
    loadActiveWishlistByGuestKey
  );
  yield takeLatest(FAVORITES_CONSTANTS.CREATE_NEW_WISHLIST, createNewWishList);
  yield takeLatest(FAVORITES_CONSTANTS.CREATE_NEW_WISHLIST_MOVE_ITEM, createNewWishListMoveItem);
  yield takeLatest(FAVORITES_CONSTANTS.DELETE_WISHLIST, deleteWishListById);
  yield takeLatest(FAVORITES_CONSTANTS.DELETE_WISHLIST_OOS, deleteOOSItemFromWishlist);
  yield takeLatest(FAVORITES_CONSTANTS.UPDATE_WISHLIST, updateExistingWishList);
  yield takeLatest(FAVORITES_CONSTANTS.DELETE_WISHLIST_ITEM, deleteWishListItemById);
  yield takeLatest(FAVORITES_CONSTANTS.UPDATE_WISHLIST_ITEM, updateWishListItem);
  yield takeLatest(FAVORITES_CONSTANTS.SEND_WISHLIST_EMAIL, sendWishListMail);
  yield takeLatest(FAVORITES_CONSTANTS.FAVORITES_REPLACE_WISHLIST_ITEM, replaceWishlistItem);
  yield takeLatest(FAVORITES_CONSTANTS.CREATE_NEW_WISHLIST_ADD_ITEM, createNewWishListAddItem);
}

export default FavoriteSaga;
